export default __webpack_public_path__ + "static/speedy7-52b5fd09bf59a4d669719cb2759cb2d5.svg";